/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .info-container[_ngcontent-%COMP%]{flex-wrap:wrap}[_nghost-%COMP%]   data-field-viewer[_ngcontent-%COMP%]{min-width:250px}@media (max-width:599px){[_nghost-%COMP%]   .info-container[_ngcontent-%COMP%]{place-content:flex-start!important;align-items:flex-start!important}}"];
export { styles as styles };
